/**
 * File này là thư mục component
 * Mục đích là quản lý thống nhất các component đầu ra, dễ dàng phân loại
 */
/**
 * Component layout
 */
import Footer from "./Footer";
import ProtectedRoute from "./ProtectedRoute";
import { Question, SelectLang } from "./RightContent";
import { AvatarDropdown, AvatarName } from "./RightContent/AvatarDropdown";

/**
 * Component form
 */
import DishSelectionModal from "./DishSelectionModal";
import ImageUpload from "./ImageUpload";
import ProFormImageUpload from "./ProFormImageUpload";
import ProFormSlugInput from "./ProFormSlugInput";
import SlugInput from "./SlugInput";
import TranslationsManager from "./TranslationsManager";

export {
  AvatarDropdown,
  AvatarName,
  DishSelectionModal,
  Footer,
  ImageUpload,
  ProFormImageUpload,
  ProFormSlugInput,
  ProtectedRoute,
  Question,
  SelectLang,
  SlugInput,
  TranslationsManager,
};
